﻿window.onunload = function () {
	// keep this. We need this function to prevent firefox caching this page in the history cache.
	if (history) history.replaceState({}, '', location.href);
};

window.onbeforeunload = function () {
	// keep this. We need this function to prevent IE11+ caching this page in the history cache.
	if (history) history.replaceState({}, '', location.href);
};

namespace eXpress.core.options {
	interface IOptionsDependencies {
		orderService: services.OrderService;
	}

	export class Options {
		private orderService: services.OrderService;
		private $options: JQuery;
		private $productCrosSell: JQuery;

		private readonly optionsEls: HTMLElement[];
		private readonly crossSellGroupsEls: HTMLElement[];
		private readonly optionToggles: { [key: string]: HTMLInputElement[]; } = {};
		private crossSellGroupToggles: HTMLInputElement[] = [];
		private selectedCrossSellUrl?: string;
		private doingApply: boolean;

		constructor(deps: IOptionsDependencies) {
			this.orderService = deps.orderService;
			this.optionsEls = html.querySelectorAll<HTMLElement>(document, '.option');
			this.crossSellGroupsEls = html.querySelectorAll<HTMLElement>(document, '.item.crossSellGroup');
		}

		public init() {
			this.$options = $(".productOptions");
			this.$productCrosSell = $(".productCrossSell");
			// reset input values:
			this.$productCrosSell.find("input.quantity-input").val("0");

			this.optionsEls.forEach(o => {
				const optionToggles = html.querySelectorAll<HTMLInputElement>(o, '.a-toggle__input');
				const option = html.querySelector<HTMLElement>(o, '.options', true);
				const optionId = option.getAttribute('id');
				if (optionId)
					this.optionToggles[optionId] = optionToggles;
			});

			// for photo finish -> only one productvariant per crossSellGroup
			this.crossSellGroupToggles = this.crossSellGroupsEls.map(csg => html.querySelector<HTMLInputElement>(csg, '.a-toggle__input', false))
				.filter(t => t) as HTMLInputElement[]; // if non - photo finish -> filter null values

			this.attachHandlers();
		}

		public attachHandlers() {
			// Define some clicks to allow the user to switch options
			// Opens the article up on mobile devices (add class open)
			this.$options.on('click', '.central-info', (e) => this.optionsOpenArticle(e));

			Object.keys(this.optionToggles).forEach(key => {
				const toggle = this.optionToggles[key];
				toggle.forEach(t => t.addEventListener('change', e => this.toggleOptionsSwitch(e, key)));
			});

			this.crossSellGroupToggles.forEach(t => t.addEventListener('change', e => this.toggleCrossSellGroup(e)));

			this.$productCrosSell.on("click", ".counter-plus", (e) => this.updateQuantity($(e.currentTarget).siblings(".quantity-input"), 1));
			this.$productCrosSell.on("click", ".counter-minus", (e) => this.updateQuantity($(e.currentTarget).siblings(".quantity-input"), -1));

			this.$productCrosSell.on("keypress", "input.quantity-input", (e) => eXpress.utils.preventInvalidInput($(e.currentTarget), /^[0-9]\d*$/, e, this.validateQuantity));

			html.querySelectorAll<HTMLInputElement>(this.$productCrosSell[0], "input.quantity-input")
				.forEach(el => el.addEventListener("change", e => this.updatePrice(e.currentTarget as HTMLInputElement, 0)));

			// Go to the next step (upsell or to cart)
			$(document).on('click', '.continue', (e) => { this.goToNextStep(e, $(e.currentTarget)); });
		}

		private toggleCrossSellGroup(e: Event) {
			const targetToggleEl = e.target as HTMLInputElement;
			if (targetToggleEl.checked) {
				this.crossSellGroupToggles
					.forEach(csgt => {
						if (csgt.getAttribute('id') !== targetToggleEl.getAttribute('id'))
							csgt.checked = false;
					});

				this.selectedCrossSellUrl = targetToggleEl.value;

			} else
				this.selectedCrossSellUrl = undefined;
		}

		private toggleOptionsSwitch(e: Event, key: string) {
			const targetToggleEL = e.target as HTMLInputElement;
			const itemToggleEls = this.optionToggles[key];
			if (targetToggleEL.checked) {
				itemToggleEls.forEach(t => {
					if (t.getAttribute('id') !== targetToggleEL.getAttribute('id'))
						t.checked = false;
				});
			}

			// not when ar video => thats is only on upload success not toggle option
			if (!targetToggleEL.classList.contains('technical-special-option-video'))
				this.applyOptions();

			// exception only 1 type of envelope option allowed
			if (key.toLowerCase().indexOf('envelop') > -1) {
				const otherEnvelopes = Object.keys(this.optionToggles).filter(k => k.toLowerCase().indexOf('envelop') > 0 && k.toLowerCase() !== key.toLowerCase());
				otherEnvelopes.forEach(k => {
					const envelopeTogglesEls = this.optionToggles[k];
					envelopeTogglesEls.forEach(et => et.checked = false);
				});
			}
		}

		private updateQuantity($textbox: JQuery, diff: number) {
			const backup = $textbox.has("[data-backup]") ? +$textbox.attr("data-backup")! : 0;
			const oldValue = isNaN(+$textbox.val()!) ? backup : +$textbox.val()!;
			let newValue = oldValue + diff;
			if (newValue < 0 || newValue > 999) {
				if (newValue < 0)
					newValue = 0;
				else if (newValue > 999)
					newValue = 999;

				$textbox.css('border', '1px solid red');
				setTimeout(function () { $textbox.animate({ borderTopColor: '#c4c2d1', borderRightColor: '#c4c2d1', borderBottomColor: '#c4c2d1', borderLeftColor: '#c4c2d1' }, 500); }, 300);
			}

			$textbox.val(newValue).attr("data-backup", newValue);
			this.updatePrice($textbox[0] as HTMLInputElement, diff);
		}

		private updatePrice(el: HTMLInputElement, diff: number): void {
			const $el = $(el);

			const backup = $el.has("[data-backup]") && !Number.isNaN(+$el.attr("data-backup")!) ? +$el.attr("data-backup")! : 0;
			$el.attr("data-backup", el.value);

			const productVariantEl = el.closest('.product-variant') as HTMLElement;
			const pvc = productVariantEl && productVariantEl.dataset.pvc;
			const quantity = +el.value;
			if (!pvc || quantity < 0) return;
			//const priceTagEl = html.querySelector(productVariantEl, '.price-tag', true);
			//const needsStar = html.querySelector(priceTagEl, '.star', false);
			//this.orderService.getPriceAsync(pvc, quantity, 0, undefined, undefined, quantity)
			//	.then(res => {
			//		const priceItem = utils.findFirst(res.priceItems, pi => pi.type.toLowerCase() === 'product');
			//		if (priceItem && priceItem.itemTotal) priceTagEl.innerHTML = priceItem.itemTotal;
			//		if (needsStar) priceTagEl.insertAdjacentElement('beforeend', needsStar);
			//	});

			const article = el.closest("article");
			let crossSellFrom = "";
			if (article) {
				crossSellFrom = article.getAttribute("data-productcode") ?? "";
			}

			core.showLoadingDialogAsync(this.applyNonPhotoFinishProductCrossSellAsync(pvc, crossSellFrom, diff === 0 ? quantity - backup : diff));
		}

		private validateQuantity(quantity: number): boolean {
			if (isNaN(quantity))
				return false;
			if (quantity < 0 || quantity > 999)
				return false;

			return true;
		}

		private applyOptions() {
			const $button = html.querySelector(document, '.continue', true);
			const cartItemId = $button.getAttribute('data-cartitemid') || '';

			const selectedOption = Object.keys(this.optionToggles)
				.reduce((pn, u) => [...pn, ...this.optionToggles[u]
					.filter(el => el.checked)
					.map(el => el.value)], []);

			const hiddenOptions = $('.hiddenOptionsGroup input').map(function () {
				//@ts-ignore
				return this.value;
			}).get();

			const optionCodes: string[] = [...selectedOption, ...hiddenOptions];

			this.singleApplyOptionsToServer(cartItemId, optionCodes, (result) => {
				if (result.html) {
					const $miniShoppingCart = html.querySelector(document, '.technical-shopping-cart-container', false);
					if ($miniShoppingCart) $miniShoppingCart.innerHTML = result.html;
				}
			});
		}

		private singleApplyOptionsToServer(cartItemId: string, optionCodes: string[], callback: (result: any) => void) {
			if (this.doingApply) {
				setTimeout(() => { this.singleApplyOptionsToServer(cartItemId, optionCodes, callback); }, 100);
				return;
			}

			this.doingApply = true;
			$.ajax({
				url: "/ajaxxhr/Options/Apply",
				type: 'POST',
				contentType: 'application/json; charset=utf-8',
				data: "{'cartItemId':'" + cartItemId + "','optionCodes' :'" + optionCodes + "'}",
				success: (result) => {
					this.doingApply = false;
					callback(result);
				}
			});
		}

		private optionsOpenArticle(e: JQuery.ClickEvent) {
			const $article = $(e.currentTarget).parent();
			if ($article.hasClass('open'))
				$article.removeClass('open');
			else {
				// Remove all other open articles
				$('.productOptions article').removeClass('open');
				$article.addClass('open');
			}
		}

		private goToNextStep(event: JQuery.ClickEvent, $button: JQuery) {
			event.preventDefault();
			// remove event to make sure the ajax request isn't sent several times + chang state of the button
			$(document).off('click', '.continue');
			$button.on('click', function () { return false; });
			$button.addClass("inactive");

			this.redirect();
		}

		private redirect() {
			if (this.selectedCrossSellUrl) {

				const selectedToggle = this.crossSellGroupToggles.filter(t => t.checked)[0];
				const selectedPvc = selectedToggle.getAttribute('id');

				const dataLayer = window.dataLayer || [];
				dataLayer.push({
					'eventCategory': 'Cross Selling',
					'eventAction': selectedPvc,
					'eventLabel': selectedPvc,
					'event': 'crossSelling'
				});

				const article = selectedToggle.closest("article");
				let crossSellFrom: string | null = "";
				if (article) {
					const gtmData = article.getAttribute("data-gtmdata");
					if (gtmData) {
						const gtmObject = JSON.parse(gtmData);
						dataLayer.push(gtmObject);
					}
					crossSellFrom = article.getAttribute("data-productcode");
				}

				// redirect to crossSell product
				if (crossSellFrom)
					document.location.href = this.selectedCrossSellUrl + '&crossSellFrom=' + crossSellFrom;
				else
					document.location.href = this.selectedCrossSellUrl;
			}
			else {
				// redirect to cart (or whatever the next page is)
				window.location.href = $(".continue").attr("href")!;
			}
		}

		private applyNonPhotoFinishProductCrossSellAsync(pvc: string, crossSellFrom: string, diff: number): JQueryPromise<any> {
			const orderQuantity: IOrderQuantiy[] = [{ pvc: pvc, crossSellFrom: crossSellFrom, quantity: diff }];
			return this.orderService.updateShoppingCartNoEditorAsync(orderQuantity);
		}
	}


	$(function () {
		const deps: IOptionsDependencies = {
			orderService: new eXpress.services.OrderService(core.context)
		};

		const optionsPage = new Options(deps);
		optionsPage.init();
	});
}
